<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"
    ></loading>
    <vue-snotify></vue-snotify>
    <b-row>
      <b-col lg="6">
        <b-card class="card-style mb-3">
          <div class="d-flex">
            <h3>Claim:</h3>
            <p class="text-muted ml-4 pl-2">{{ activeClaimStr }}</p>
          </div>

          <div class="d-flex">
            <h3>Industry:</h3>
            <p class="text-muted ml-3">IT</p>
          </div>

          <div class="d-flex">
            <h3>Analyst:</h3>
            <p class="text-muted ml-3 pl-1">Analyst</p>
          </div>
        </b-card>

        <b-card>
          <b-row align-v="center" slot="header">
            <b-col cols="8">
              <h3 class="mb-0">Projects</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <vuetable
                ref="vuetable_projects"
                :api-mode="false"
                :fields="fields"
                :sort-order="sortOrderProjects"
                :per-page="perPage"
                :data-manager="dataManagerProjects"
                pagination-path="pagination"
                @vuetable:pagination-data="onPaginationDataProject"
              >
                <div slot="custom-actions">
                  <b-button size="sm" to="" variant="warning">View</b-button>
                </div>
              </vuetable>
            </b-col>
            <b-col cols="12">
              <div style="padding-top: 10px">
                <vuetable-pagination-info
                  ref="paginationInfoProject"
                ></vuetable-pagination-info>
                <vuetable-pagination
                  class="float-right"
                  ref="pagination_project"
                  @vuetable-pagination:change-page="onChangePageProjects"
                ></vuetable-pagination>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col lg="6">
        <b-card>
          <b-row align-v="center" slot="header">
            <b-col cols="8">
              <h3 class="mb-0">Checklist - Required Items</h3>
            </b-col>
            <b-col cols="4" class="text-right"> </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <vuetable
                ref="vuetable_check_list"
                :api-mode="false"
                :fields="checklistfields"
                :sort-order="sortOrderCheckList"
                :per-page="perPage"
                :data-manager="dataManagerCheckList"
                pagination-path="pagination"
                @vuetable:pagination-data="onPaginationDataCheckList"
              >
                <template slot="custom-filename" scope="props">
                  <span
                    v-html="truncateText(multiFileUploadString(props.rowData))"
                  ></span>
                  <a
                    v-if="multiFileUploadString(props.rowData).length > 60"
                    class="a-style"
                    @click="
                      setActiveFileStr(multiFileUploadString(props.rowData))
                    "
                    v-b-modal.modal-file-str
                  >
                    View More</a
                  >
                </template>
                <template slot="custom-actions" scope="props">
                  <b-button
                    variant="outline-success"
                    :disabled="
                      !props.rowData.documentType.id || props.rowData.isUploaded
                    "
                    @click="
                      $bvModal.show('bv-modal-example-2');
                      uploadRowSelect(props.rowData);
                    "
                    size="sm"
                    ><i class="fa-solid fa-plus pr-2"></i>File</b-button
                  >
                </template>
              </vuetable>
            </b-col>
            <b-col cols="12">
              <div style="padding-top: 10px">
                <vuetable-pagination-info
                  ref="paginationInfoCheckList"
                ></vuetable-pagination-info>
                <vuetable-pagination
                  class="float-right"
                  ref="pagination_check_list"
                  @vuetable-pagination:change-page="onChangePageCheckList"
                ></vuetable-pagination>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="4"> </b-col>
      <b-col lg="8"> </b-col>
    </b-row>

    <!-- Start Upload Model -->

    <b-modal id="bv-modal-example-2" hide-footer>
      <template #modal-title>
        <h3>Upload a File</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col lg="10">
            <div class="form-group">
              <div>
                <b-form-file
                  multiple
                  v-model="upload_file"
                  variant="primary"
                  placeholder="Choose or drop files here..."
                  drop-placeholder="Drop files here..."
                  :file-name-formatter="formatNames"
                ></b-form-file>
                <b-progress
                  :value="client_upload_progress"
                  :max="max"
                  show-progress
                  animated
                  class="mt-2"
                  variant="warning"
                  v-if="isUploading == 1"
                  height="1.5rem"
                ></b-progress>
              </div>
            </div>
          </b-col>
          <b-col lg="2">
            <b-button
              variant=""
              :disabled="isUploading == 1"
              @click="upload_file = null"
              ><i class="fa fa-refresh" aria-hidden="true"></i>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <span class="alert alert-info-custom custom-pad-alert mt-2"
              ><i class="fa-solid fa-circle-info"></i> You can choose multiple
              files to upload
            </span>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-3">
        <b-button
          :disabled="!upload_file || isUploading == 1"
          variant="primary"
          @click="uploadFile()"
          >Upload</b-button
        >
        <b-button variant="" @click="$bvModal.hide('bv-modal-example-2')"
          >Cancel</b-button
        >
      </div>
    </b-modal>
    <!-- End Upload Model -->

    <!-- Start File Str Modal -->
    <b-modal id="modal-file-str" hide-footer>
      <template #modal-title>
        <h3>Detail View</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col cols="12">
            <p v-html="activeFileStr"></p>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-5">
        <b-button variant="" @click="$bvModal.hide('modal-file-str')"
          >Cancel</b-button
        >
      </div>
    </b-modal>
    <!-- End File Str Modal -->
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "../Vuetable/VuetablePaginationBootstrap4";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";
import NotificationDef from "./ProjectDef.js";
import ChecklistDef from "./ChecklistDef.js";
import { mapActions, mapState } from "vuex";
import mixins from "../../mixins/common.js";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  props: ["claim_id"],
  data() {
    return {
      fields: NotificationDef,
      checklistfields: ChecklistDef,
      projectData: [],
      checkListData: [],
      perPage: 10,
      sortOrderProjects: [],
      sortOrderCheckList: [],
      upload_file: null,
      isLoading: false,
      fullPage: true,
      activeDocumentType: [],
      value: 0,
      max: 100,
      isUploading: 0,
      activeFileStr: "",
    };
  },
  watch: {
    activeClaimData(newVal, oldVal) {
      this.$refs.vuetable_projects.refresh();
    },
    checkListData(newVal, oldVal) {
      this.$refs.vuetable_check_list.refresh();
    },
    claim_id: function (newVal, oldVal) {
      this.refreshClaimDocs();
    },
  },
  computed: {
    client_upload_progress: {
      get() {
        return this.$store.state.client.client_upload_progress;
      },
      set(val) {
        this.$store.state.client.client_upload_progress = val;
      },
    },
    activeClaimData: {
      get() {
        return this.$store.state.activeClaimData;
      },
      set(val) {
        this.$store.state.activeClaimData = val;
      },
    },
    activeClaimStr() {
      if (this.claim_id) {
        return (
          this.activeClaimData.fiscalYear +
          " | " +
          this.getMonthNameFormValue(this.activeClaimData.fiscalMonth) +
          " " +
          this.activeClaimData.fiscalDay +
          " " +
          "FYE" +
          " | " +
          this.ammendString(this.activeClaimData.isAmendment)
        );
      } else {
        return "";
      }
    },
    claimStatusStr() {
      return this.activeClaimData.claimStatus
        ? this.claimStatusString(this.activeClaimData.claimStatus)
        : "";
    },
  },
  mixins: [mixins],
  methods: {
    ...mapActions("client", [
      "getUserClaims",
      "getClaimDocuments",
      "uploadDocumentFile",
    ]),
    setActiveFileStr(activeFileStr) {
      this.activeFileStr = activeFileStr;
    },
    formatNames(files) {
      return files.length === 1
        ? files[0].name
        : `${files.length} files selected`;
    },
    refreshClaimDocs() {
      this.isLoading = true;
      const claimParams = {
        claim_id: this.claim_id,
      };
      if (this.claim_id) {
        this.getClaimDocuments(claimParams).then((data) => {
          if (data.data.errors) {
          } else {
            this.checkListData = data.data;
          }
          this.isLoading = false;
        });
      } else {
        this.checkListData = [];
        this.isLoading = false;
      }
    },
    uploadFile() {
      this.isUploading = 1;
      let formData = new FormData();
      for (let file of this.upload_file) {
        formData.append("file[]", file);
      }

      //formData.append("claim_id", this.claim_id);
      formData.append("documentId", this.activeDocumentType.id);
      //formData.append("document_type_id", this.activeDocumentType.id);
      this.uploadDocumentFile(formData).then((data) => {
        if (data.data.data) {
        } else {
        }
        this.upload_file = null;
        this.$bvModal.hide("bv-modal-example-2");
        this.refreshClaimDocs();
        this.isUploading = 0;
        this.client_upload_progress = 0;
      });
    },
    uploadRowSelect(data) {
      this.activeDocumentType = data;
    },
    onPaginationDataProject(paginationData) {
      this.$refs.pagination_project.setPaginationData(paginationData);
      this.$refs.paginationInfoProject.setPaginationData(paginationData);
    },
    onChangePageProjects(page) {
      this.$refs.vuetable_projects.changePage(page);
    },
    dataManagerProjects(sortOrder, pagination) {
      let local = [];
      if (this.activeClaimData.projects) {
        local = this.activeClaimData.projects;
      }

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetable_projects.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },

    onPaginationDataCheckList(paginationData) {
      this.$refs.pagination_check_list.setPaginationData(paginationData);
      this.$refs.paginationInfoCheckList.setPaginationData(paginationData);
    },
    onChangePageCheckList(page) {
      this.$refs.vuetable_check_list.changePage(page);
    },
    dataManagerCheckList(sortOrder, pagination) {
      let local = this.checkListData;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetable_check_list.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
  },
  mounted() {
    const userdata = {};
    this.getUserClaims(userdata).then((data) => {
      if (data.data.errors) {
      } else {
      }
    });
  },
};
</script>

<style scoped>
.card-style:hover {
  -webkit-box-shadow: 0 6px 16px rgb(52 105 203 / 16%);
  box-shadow: 0 6px 16px rgb(52 105 203 / 16%);
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.3s ease-in;
}
.custom-pad-alert {
  padding: 5px;
}
.alert-info-custom {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
</style>
